<template>
  <div id="operate">
    <div class="trader-ban">
      <img v-if="pzPath === 'Operateday'" :src="pzPicture.Operateday">
      <img v-else-if="pzPath === 'Operateweek'" :src="pzPicture.Operateweek">
      <img v-else-if="pzPath === 'Operatemonth'" :src="pzPicture.Operatemonth">
      <img v-else-if="pzPath === 'Operatehuhui'" :src="pzPicture.Operatehuhui">
      <img v-else-if="pzPath === 'Operatevip'" :src="pzPicture.Operatevip"> <!--add by kasun, added image path for VIP配资 button-->
    </div>
    <div class="trader-toggle">
      <div class="trader-toggle-cen">
        <el-row :gutter="100">
          <el-col :span="2">
            <router-link to="/operate/operateday" class="assist" >
            </router-link>
          </el-col>
          <el-col :span="4">
            <router-link to="/operate/operateday" class="assist" style="background: linear-gradient(to bottom, #FF646E, #FF121D);">
<!--              <img src="https://dnzq.oss-accelerate.aliyuncs.com/front/atpz.png">-->
              <span>按天配资</span>
            </router-link>
          </el-col>
          <el-col :span="4">
            <router-link to="/operate/operateweek" class="assist" style="background: linear-gradient(to bottom, #fbb65d, #c67b18);">
              按周配资
            </router-link>
          </el-col>
          <el-col :span="4">
            <router-link to="/operate/operatemonth" class="assist" style="background: linear-gradient(to bottom, #D1B08A, #9B6E44);">
              按月配资
            </router-link>
          </el-col>
          <el-col :span="4">
            <router-link to="/operate/operatehuhui" class="assist" style="background: linear-gradient(to bottom, #5285AF, #165085);">
              免息配资
            </router-link>
          </el-col>
          <el-col :span="4">
            <router-link to="/operate/operatevip" class="assist" style="background: linear-gradient(to bottom, #478563, #168548);">
              VIP配资
            </router-link>
          </el-col>
          <el-col :span="2">
            <router-link to="/operate/operateday" class="assist">
            </router-link>
          </el-col>
        </el-row>

      </div>

      <!--<div class="trader-toggle-cen">
        <router-link to="/operate/operateday" active-class="Active">
          <i class="iconfont icon-tian"></i>按天配资
        </router-link>
        <router-link to="/operate/operateweek" active-class="Active">
          <i class="iconfont icon-week"></i>按周配资
        </router-link>
        <router-link to="/operate/operatemonth" active-class="Active">
          <i class="iconfont icon-yue"></i>按月配资
        </router-link>
        <router-link to="/operate/operatehuhui" active-class="Active">
          <i class="iconfont icon-hui"></i>免息配资
        </router-link>
      </div>-->
    </div>
    <!-- <keep-alive> -->
      <router-view name="child"></router-view>
    <!-- </keep-alive> -->
  </div>
</template>
<script>
import $ from "jquery";

export default {
  name: "operate",
  components: {
  },
  data() {
    return {
      pzPicture:{
        'Operateday': require('../assets/img/operateDay.png'),
        'Operateweek': require('../assets/img/operateWeek.png'),
        'Operatemonth' : require('../assets/img/operateMonth.png'),
        'Operatehuhui' : require('../assets/img/operateHuhui.png'),
        'Operatevip' : require('../assets/img/operateVip.png')
      },
      pzPath:'Operateday'
    };
  },
  mounted() {
    // $("#wrapper").css("background", "#737373");
    $("body,html").css({ overflow: "inherit", height: "100%" });
    this.pzPath = this.$route.name;
  },
  methods: {

  },
  watch:{
    $route(to,from){
      this.pzPath = this.$route.name;
    }
  },
};
</script>
<style scoped>
#operate{
  min-width: 1000px;
}
.trader-ban {
  /*height: 500px;*/
  overflow: hidden;
}
.trader-ban img {
  width: 100%;
}
.trader-ban img {
  width: 100%;
}
.trader-toggle {
  width: 100%;
  /*line-height: 50px;*/
  background-color: #f3f3f3;
  border-top: 1px solid #dddddd;
  border-bottom: 1px solid #dddddd;
  margin: 0 0 20px;
}
.trader-toggle-cen {
  width: 1400px;
  margin: 0 auto;
  justify-content: space-between;
}
.trader-toggle-cen a {
  margin: 10px 0;
  text-align: center;
  color: #fff;
  font-size: 18px;
  line-height: 50px;
  display: block;
  border-radius: 4px;
  font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
}
/*.trader-toggle-cen a > i {
  display: inline-block;
  font-size: 35px;
  line-height: 50px;
  vertical-align: top;
}*/
.trader-toggle-cen img {
  width: 15%;
}
  .assist{

  }
</style>





// WEBPACK FOOTER //
// src/components/operate.vue